module.exports = __webpack_public_path__ + "img/computer_1.f346bbfd.png";